import { Component, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import { ApiService } from '../../../services/api.service';
declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-financial-statements',
  templateUrl: './financial-statements.component.html',
  styleUrls: ['./financial-statements.component.css']
})
export class FinancialStatementsComponent implements OnInit {

  options: any; //chart
  financial_status = {
    date: '',
    acc_current: 0, //ฝากกระแสรายวัน
    acc_deposits: 0, //ฝากคลัง
    acc_fixed: 0, //ฝากประจำ
    acc_savings: 0, //ฝากออมทรัพย์
    acc_sum: 0
  };
  performance_sum = {
    fiscal_year: [] as any, //ปีงบประมาณ
    total_income: [] as any, //รวมรายได้
    total_charge: [] as any, //รวมค่าใช้จ่าย
    highlow_net: [] as any, //รายได้สูง(ต่ำ)กว่าค่าใช้จ่ายสุทธิ
    highlow_cumulative: [] as any //รายได้สูง(ต่ำ)กว่าค่าใช้จ่ายสะสม
  }
  all_performance: any;

  admin_data: any;
  displayList: boolean = true;
  displayPdf: boolean = false;
  fiscal_year: any;
  pdfSrc: any;
  data_report = [] as any;
  years = [] as any;
  year_select = '';
  data_select = [] as any;
  pdfName: any;
  page = 1;
  count = 0;
  tableSize = 15;
  constructor(
    public services: ApiService
  ) { }

  ngOnInit(): void {
    document.getElementById('financial-c')!.classList.toggle("active");
    this.getFinancial();
    this.getPerformancesum();
    this.fiscal_year = this.services.fiscal_year;
    this.getDataAll();
  }
  
  ngOnDestroy(){
    if(document.getElementById('financial-c')){
      document.getElementById('financial-c')!.classList.remove("active");
    }
  }

  getFinancial() {
    var account: any;
    var data_all = [] as any;
    this.services.get('m_financialstatus').then((res: any) => {
      res.forEach((data: any) => {
        if (data.status == 'Enable') {
          data_all.push(data)
        }
      });

      data_all = data_all.sort((a:any,b:any) => (a.date > b.date) ? -1 : ((b.date > a.date) ? 1 : 0))
      account = JSON.parse(data_all[0].account);
      this.financial_status.date = this.dateThai(data_all[0].date);
      account.acc_current.forEach((data: any) => {
        this.financial_status.acc_current += data.acc_amount
      });
      account.acc_deposits.forEach((data: any) => {
        this.financial_status.acc_deposits += data.acc_amount
      });
      account.acc_fixed.forEach((data: any) => {
        this.financial_status.acc_fixed += data.acc_amount
      });
      account.acc_savings.forEach((data: any) => {
        this.financial_status.acc_savings += data.acc_amount
      });
      this.financial_status.acc_sum = [this.financial_status.acc_current, this.financial_status.acc_deposits,
      this.financial_status.acc_fixed, this.financial_status.acc_savings].reduce((a, b) => a + b, 0);
    })
  }
  async getPerformancesum() {
    await this.services.get('m_performancesum').then(async (res: any) => {
      this.all_performance = await res.filter((res: any) => {
        return res.status.match('Enable')
      })
      var fiscal_year = [] as any;
      var total_income = [] as any;
      var total_charge = [] as any;
      var highlow_net = [] as any;
      var highlow_cumulative = [] as any;
      var sum = 0;
      this.all_performance = this.all_performance.sort((a: any, b: any) => (a.fiscal_year < b.fiscal_year) ? -1 : ((b.fiscal_year < a.fiscal_year) ? 1 : 0))
      this.all_performance.forEach((data: any) => {
        fiscal_year.push(parseInt(data.fiscal_year))
        total_income.push(parseFloat(data.total_income))
        total_charge.push(parseFloat(data.total_charge))
        highlow_net.push(Math.round((((parseFloat(data.total_income) - parseFloat(data.total_charge))) + Number.EPSILON) * 100) / 100)
        sum += (parseFloat(data.total_income) - parseFloat(data.total_charge))
        sum += parseFloat(data.previous_error)
        highlow_cumulative.push(Math.round(((sum) + Number.EPSILON) * 100) / 100)
        data.highlow_net = Math.round((((parseFloat(data.total_income) - parseFloat(data.total_charge))) + Number.EPSILON) * 100) / 100
        data.highlow_cumulative = Math.round(((sum) + Number.EPSILON) * 100) / 100
      });
      this.performance_sum.fiscal_year = await fiscal_year;
      this.performance_sum.total_income = await total_income;
      this.performance_sum.total_charge = await total_charge;
      this.performance_sum.highlow_net = await highlow_net;
      this.performance_sum.highlow_cumulative = await highlow_cumulative;

      this.options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#c3bdbd'
            }
          }
        },
        dataZoom: {
          type: 'inside'
        },
        legend: {
          data: ['รวมรายได้', 'รวมค่าใช้จ่าย', 'รายได้สูง(ต่ำ)กว่าค่าใช้จ่ายสุทธิ']
        },
        toolbox: {
          show: true,
          showTitle: false, // hide the default text so they don't overlap each other
          feature: {
            saveAsImage: {
              show: true,
              title: 'บันทึกรูปภาพ'
            },
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.performance_sum.fiscal_year,
            axisLabel: {
              interval: 0,
              rotate: 1000 //If the label names are too long you can manage this by rotating the label.
            },
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'บาท',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: 'รวมรายได้',
            type: 'bar',
            data: this.performance_sum.total_income
          },
          {
            name: 'รวมค่าใช้จ่าย',
            type: 'bar',
            data: this.performance_sum.total_charge
          },
          {
            name: 'รายได้สูง(ต่ำ)กว่าค่าใช้จ่ายสุทธิ',
            type: 'line',
            data: this.performance_sum.highlow_net
          }
        ],
        color: ['#1bcfb4', '#198ae3', '#fed713']
      };
      this.all_performance = this.all_performance.reverse()
    })
  }
  getDataAll() {
    this.services.getByType('auditor_report').then((res: any) => {
      this.getReport(res);
    })
  }
  getReport(data: any) {
    let year = [] as any;
    let report = [] as any
    data.forEach((file: any) => {
      if (file.status == 'Enable') {
        report.push(file)
      }
    });
    this.data_report = report.sort((a: any, b: any) => (a.year > b.year) ? -1 : ((b.year > a.year) ? 1 : 0))
    this.data_report.forEach((data: any) => {
      data.year = parseInt(data.year)
      data.date_report = this.dateThai(data.date_report);
      this.data_select.push(data);
      year.push(data.year);
    });
    this.years = [...new Set(year)].sort();
  }
  selectYear() {
    this.data_select = [];
    this.data_report.forEach((data: any) => {
      if (this.year_select == data.year) {
        this.data_select.push(data);
      }
    });
  }

  onClickDownload(file_name: any, name: any) {
    this.pdfSrc = "https://ogc.mapedia.co.th/api/v1/lrfund/m_file/" + file_name;
    FileSaver.saveAs(this.pdfSrc, name);
  }
  onClickView(file_name: any, name: any) {
    this.displayList = false;
    this.displayPdf = true;
    this.pdfName = name;
    this.pdfSrc = "https://ogc.mapedia.co.th/api/v1/lrfund/m_file/" + file_name;
  }
  onClickClose() {
    this.displayList = true;
    this.displayPdf = false;
  }

  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }

  dateThai(date: any) {
    var newDate = new Date(date).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    return newDate;
  }
  onTableDataChange(event: any) {
    this.page = event;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
}
